// import React, { useState } from 'react';
// import { menuItems } from '../../Dashboard/dashboardUtilts'; 
// import './TopNavBar.css'; 

// const TopNavBar = ({ onPlaceOrder, onReport, onHistory, onshowAd }) => {
//   const [activeIndex, setActiveIndex] = useState(null);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false); 
//   const sidemenuItems = menuItems({ onPlaceOrder, onReport, onHistory, onshowAd });

//   const handleItemClick = (index, onClick) => {
//     setActiveIndex(index);
//     onClick();
//   };

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen); 
//   };

//   return (
//     <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
//       <div className="container-fluid">
      
//       <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
//       <a className="navbar-brand">DASHBOARD</a>
//         <button className="navbar-toggler" onClick={toggleSidebar}>
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         <ul className="sidebar-menu">
//           {sidemenuItems.map((item, index) => {
//             const isActive = index === activeIndex;

//             return (
//               <li key={item.label} className={`sidebar-item ${isActive ? 'active' : ''}`}>
//                 <a 
//                   href="#"
//                   className="sidebar-link"
//                   onClick={() => handleItemClick(index, item.onClick)}
//                 >
//                   {item.icon}
//                   <span className="sidebar-item-label">{item.label}</span>
//                 </a>
//               </li>
//             );
//           })}
//         </ul>

//         </div>

//         {/* Navbar Links (Collapsible on Mobile) */}
//         <div className="collapse navbar-collapse" id="navbarNav">
//           <ul className="navbar-nav ms-auto gap-3">
//             {sidemenuItems.map((item, index) => {
//               const isActive = index === activeIndex;

//               return (
//                 <li key={item.label} className="nav-item">
//                   <a 
//                     className={`nav-link ${isActive ? 'active' : ''}`}
//                     onClick={() => handleItemClick(index, item.onClick)}
//                   >
//                     {/* Icon and Label */}
//                     {item.icon}
//                     <span className="d-none d-lg-inline ms-2">{item.label}</span>
//                   </a>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default TopNavBar;




import React, { useState } from 'react';
import { menuItems } from '../../Dashboard/dashboardUtilts'; 
import './TopNavBar.css'; 

const TopNavBar = ({ onPlaceOrder, onReport, onHistory, onshowAd }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); 
  
  const sidemenuItems = menuItems({ onPlaceOrder, onReport, onHistory, onshowAd });

  const handleItemClick = (index, onClick) => {
    setActiveIndex(index);
    onClick();
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); 
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
      <div className="container-fluid">
        <a className="navbar-brand">DASHBOARD</a>

        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <ul className="sidebar-menu">
            {sidemenuItems.map((item, index) => {
              const isActive = index === activeIndex;

              return (
                <li key={item.label} className={`sidebar-item ${isActive ? 'active' : ''}`}>
                  <a 
                    className="sidebar-link"
                    onClick={() => handleItemClick(index, item.onClick)}
                  >
                    {item.icon}
                    <span className="sidebar-item-label">{item.label}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Navbar Toggler (Hamburger Icon) */}
        <button className="navbar-toggler" onClick={toggleSidebar}>
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links (Collapsible on Mobile) */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto gap-3">
            {sidemenuItems.map((item, index) => {
              const isActive = index === activeIndex;

              return (
                <li key={item.label} className="nav-item">
                  <a 
                    className={`nav-link ${isActive ? 'active' : ''}`}
                    onClick={() => handleItemClick(index, item.onClick)}
                  >
                    {item.icon}
                    <span className="d-none d-lg-inline ms-2">{item.label}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default TopNavBar;
